import { dealerApi, dealersApi } from '@/backend'

export default {
  state: {
    dealers: [],
  },
  getters: {
    getDealers: state => state.dealers,
  },
  mutations: {
    setDealers (state, payload) {
      state.dealers = payload
    }
  },
  actions: {
    async loadDealers ({ commit }) {
      dealersApi.getDealers(async (error, data) => {
        if (error) {
          console.error(error)
          return
        }
        await commit('setDealers', data)
      })
    },
    async deleteDealer ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        dealerApi.deleteDealer(payload.dealer.id, async (error) => {
          if (error) {
            console.error(error)
            reject(error.response.body.message)
            return
          }
          await dispatch('loadDealers')
          resolve()
        })
      })
    },
    async addDealer ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        dealerApi.createDealer(payload.dealerName, async (error) => {
          if (error) {
            console.error(error)
            reject(error.response.body.message)
            return
          }
          await dispatch('loadDealers')
          resolve()
        })
      })
    },
    async updateDealer ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        dealerApi.updateDealer(payload.dealer.id, payload.newDealerName, async (error) => {
          if (error) {
            console.error(error)
            reject(error.response.body.message)
            return
          }
          await dispatch('loadDealers')
          resolve()
        })
      })
    }
  }
}